import { render, staticRenderFns } from "./OrderExchangeRecive.vue?vue&type=template&id=4d5cc003&scoped=true"
import script from "./OrderExchangeRecive.vue?vue&type=script&lang=js"
export * from "./OrderExchangeRecive.vue?vue&type=script&lang=js"
import style0 from "./OrderExchangeRecive.vue?vue&type=style&index=0&id=4d5cc003&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5cc003",
  null
  
)

export default component.exports